import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Divider } from '@material-ui/core';

import { ROUTES } from '../../core/router/routes';
import * as CommonSelectors from '../../shared/redux/commonSelectors';
import GroupCategories from './GroupCategories';
import useMainProgressContext from '../../components/progress/MainProgress/context/MainProgressContext';
import PageView from '../../components/PageView';
import { PANEL_VIEW } from '../../components/SearchPanel/enum/searchPanelProps';
import Button from '../../components/form/elements/Button';
import { BUTTON_VARIANT } from '../../components/form/enum/formProps';
import Panel from '../../components/Tabs/Panel';
import { useGetCategoriesQuery } from '../category/api/categoryApi';

import './dashboard.scss';

const Dashboard: FC = () => {
  const history = useHistory();
  const { mainCategories, isSuccess } = useGetCategoriesQuery(
    {},
    {
      selectFromResult: (result) => {
        const rootCategory = result.data?.find((category) => {
          return !category.parent;
        });

        return {
          ...result,
          mainCategories:
            result.data?.filter((category) => {
              return rootCategory
                ? rootCategory.subcategories.find((subcategory) => {
                    return subcategory.id === category.id;
                  })
                : false;
            }) || [],
        };
      },
    },
  );
  const activeMenuItem = useSelector(CommonSelectors.activeMenuItem);
  const { hide } = useMainProgressContext();

  useEffect(() => {
    isSuccess && hide();
    if (isSuccess && !mainCategories.length) {
      history.push(ROUTES.ERROR_403);
    }
  }, [isSuccess]);

  return (
    <PageView
      showMenu={mainCategories.length > 1}
      view={PANEL_VIEW.FULL}
      className="Dashboard"
      showMostSearched={false}
    >
      {mainCategories.map(({ id, name, subcategories, image }) => {
        return (
          <div className="Dashboard-Category" key={id}>
            <Panel index={id} value={activeMenuItem || mainCategories[0].id}>
              <div className="Dashboard-Category-Header">
                <div>
                  <img src={image?.gcsUrl} alt={`${name}`} />
                </div>
                <h2>{name}</h2>
              </div>
              <GroupCategories subcategories={subcategories} />
            </Panel>
          </div>
        );
      })}
      <Divider className="Dashboard-Divider" />
      <div className="Dashboard-Category">
        <Button
          variant={BUTTON_VARIANT.TEXT}
          text="button.back_to_top"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          endIcon={<ExpandLessIcon />}
        />
      </div>
    </PageView>
  );
};

export default Dashboard;
